import axios from 'axios'
import vue from 'vue'
import { Message, MessageBox } from 'element-ui';
import router from '@/router'
import store from '@/store'
console.log('process.env.BASE_API', process.env.BASE_API)
//axios.defaults.baseURL = process.env.BASE_API

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// 设置请求request超时时长
axios.defaults.timeout = 10000;
//axios.defaults.withCredentials = true;
// 请求拦截器
axios.interceptors.request.use(function (config) {
  // let jwt = window.sessionStorage.jwt;
  // let resUrl = JSON.parse(localStorage.getItem('appInfo'))
  // if (jwt!== 'null'&& jwt!== null && jwt !=='') {
  //     config.headers.Authorization = resUrl.app + ' ' + jwt;
  // }
  return config;
}, function (error) {
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error);
})

// 响应拦截器，响应超时不能设置
axios.interceptors.response.use(
  function (response) {
    console.log(response);
    const code = response.status
    if (code < 200 || code > 300) {
      if (code === 400) {
        Message({
          message: response.data,
          type: 'error',
          duration: 5 * 1000
        })
      }
      if (response.status === 401) {
        router.push({ name: 'register' })
      }
      return Promise.reject('error')
    } else {
      return response;
    }
  },
  function (error) {
    // 提示响应错误信息
    let errorMsg = ''
    if (error.message == 'Network Error') {
      errorMsg = '网络错误'
    } else if (error.message == 'timeout of 5000ms exceeded') {
      errorMsg = '连接超时'
    } else if (error.response.status == 400) {
      errorMsg = error.response.data.data;
    } else if (error.response.status === 401) {
      errorMsg = error.message
      router.push({ name: 'register' })
    } else {
      errorMsg = error.message
    }
    console.log(error);
    Message({
      message: errorMsg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error);
  })

// 封装axios的post请求
export function fetch(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      })
  })
}
export function get(url, params) {
  console.log("REQUEST METHOD:GET,PARAMS:", JSON.stringify(params))
  return new Promise((resolve, reject) => {
    axios.get(url, params)
      .then(response => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      })
  })
}

export default {
  post(url, params) {
    return fetch(url, params);
  },
  get
}


// WEBPACK FOOTER //
// ./src/axios/api.js